module.exports = __webpack_public_path__ + "static/tdcw-bc-back-white-4e46761f5a4842e1bd81a20ca5b39315.png";